<template>
  <div>
    <div class="text-container">
  <div>
    <h1>Contact Us</h1>
    <p>{{ pageDescription}}</p>
    <router-link to="/">Home Page</router-link>
  </div>
</div>
  </div>
</template>

<script>

export default {
  data: () => ({
    pageDescription: `Felis imperdiet proin fermentum leo vel orci porta non pulvinar. At lectus urna duis convallis convallis tellus
      id interdum velit.
      Egestas pretium aenean pharetra magna ac. Purus ut faucibus pulvinar elementum integer enim neque volutpat ac.
      Est ullamcorper eget nulla facilisi etiam dignissim diam quis enim. Fermentum odio eu feugiat pretium nibh ipsum
      consequat nisl.
      Aliquam vestibulum morbi blandit cursus risus at ultrices mi tempus. Fusce id velit ut tortor pretium viverra
      suspendisse.
      Interdum velit euismod in pellentesque massa placerat duis ultricies lacus. Sed elementum tempus egestas sed sed
      risus pretium quam.
      Cursus sit amet dictum sit amet justo donec. Viverra mauris in aliquam sem fringilla ut morbi. Consequat nisl vel
      pretium lectus.
      Libero justo laoreet sit amet cursus sit amet dictum. Sit amet aliquam id diam maecenas ultricies mi eget.
      Tincidunt id aliquet risus feugiat in ante metus. Urna duis convallis convallis tellus id interdum velit.`,
  }),
};
</script>

<style scoped>
.text-container {
  display: flex;
  flex-direction: row-reverse;
  margin: 50px;
}
.text-container > div {
  margin: 0 30px 0 30px;
}
.text-container a {
  font-size: 22px;
}

p {
  font-size: 22px;
}
</style>
